import React from 'react';
import { Check } from 'lucide-react';
export function InterventionSection() {
  return <section className="bg-dark py-20 px-4 border-t border-gray-800" data-id="element-60">
      <div className="max-w-[900px] mx-auto flex flex-col items-center text-center" data-id="element-61">
        <h2 className="md:text-4xl font-bold text-white mb-8 text-[28px]" data-id="element-62">
          Esto no es una clase
        </h2>

        <div className="text-lg md:text-xl text-white mb-10 space-y-4 max-w-3xl" data-id="element-63">
          <p data-id="element-64">No vienes a aprender más.</p>
          <p data-id="element-65">Vienes a tomar decisiones que cambian cómo opera tu negocio.</p>
          <p data-id="element-66">Esto es una intervención.</p>
          <p data-id="element-67">En esta sesión vas a ver con claridad:</p>
        </div>

        <div className="flex flex-col items-start text-left gap-4 w-full max-w-md mx-auto" data-id="element-68">
          <div className="flex items-center gap-3" data-id="element-69">
            <Check className="text-accent shrink-0" size={24} data-id="element-70" />
            <span className="text-xl text-white font-medium" data-id="element-71">
              qué eliminar,
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-72">
            <Check className="text-accent shrink-0" size={24} data-id="element-73" />
            <span className="text-xl text-white font-medium" data-id="element-74">
              qué sostener,
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-75">
            <Check className="text-accent shrink-0" size={24} data-id="element-76" />
            <span className="text-xl text-white font-medium" data-id="element-77">
              qué priorizar,
            </span>
          </div>
          <div className="flex items-center gap-3" data-id="element-78">
            <Check className="text-accent shrink-0" size={24} data-id="element-79" />
            <span className="text-xl text-white font-medium" data-id="element-80">
              y dónde está tu verdadero 20%.
            </span>
          </div>
        </div>
      </div>
    </section>;
}